import {
  orderSourceTypeItems,
  orderSourceTypeOthers,
  orderSourceTypeSales,
  orderSourceTypeShopPaymentPoints,
  orderSourceTypeShops,
  orderSourceTypeShopSalePoints,
  orderSourceTypeUsers,
  orderTypeOrderAdd,
  orderTypeOrderRemove,
} from "../validation/vars"

export function castOrderTypeToText(typeOrder: string): string {
  switch (typeOrder) {
    case orderTypeOrderAdd:
      return "Приходный"
    case orderTypeOrderRemove:
      return "Расходный"
    default:
      return typeOrder
  }
}

export function castOrderSourceTypeToText(sourceType: string): string {
  switch (sourceType) {
    case orderSourceTypeShops:
      return "Магазины"
    case orderSourceTypeItems:
      return "Вещи"
    case orderSourceTypeUsers:
      return "Пользователи"
    case orderSourceTypeSales:
      return "Продажи"
    case orderSourceTypeOthers:
      return "Прочее"
    case orderSourceTypeShopSalePoints:
      return "Точки продаж"
    case orderSourceTypeShopPaymentPoints:
      return "Методы оплаты"
    default:
      return sourceType
  }
}
